import { DeviceBadgeLabel, type DeviceBadgeTone } from './DeviceBadge.styles';

export type { DeviceBadgeTone };

export const DeviceBadge = ({
  tone = 'muted',
  children,
}: {
  tone?: DeviceBadgeTone;
  children: string;
}) => <DeviceBadgeLabel $tone={tone}>{children}</DeviceBadgeLabel>;
